import styled from 'styled-components';
import { mediaQuery } from 'components';

export const Container = styled.section`
  width: 100%;
  padding-left: 1rem;
  padding-right: 1rem;
  margin: 0rem auto 0rem;

  ${mediaQuery.medium`
    max-width: 1180px;
  `};
`;

export const StepperWrapper = styled.div`
  display: flex;
  justify-content: center;
  position: relative;
  top: 0.25rem;

  ${mediaQuery.medium`
    margin-top: 1rem;
    top: 0;
  `};
`;

export const LogoWrapper = styled.div`
  display: block;
  width: 100px;
  justify-content: flex-start;
  margin-top: 1rem;

  ${mediaQuery.medium`
    margin-top: 0;
    margin-right: 25px;
    position: absolute;
    left: 0;
  `};
`;

export const BackToCartButton = styled.div`
  display: none;
  align-items: center;
  cursor: pointer;

  p {
    margin-bottom: 0;
  }

  p:hover {
    text-decoration: underline;
  }

  ${mediaQuery.medium`
    display: inline-flex;
    position: absolute;
    left: 150px;
  `};
`;

export const Header = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 6rem;

  ${mediaQuery.medium`
    position: relative;
    flex-direction: row;
    justify-content: flex-end;
    height: 6rem;
  `};

  ${mediaQuery.large`
    justify-content: center;
  `};
`;

export const LogoContainer = styled.span`
  height: 3.25rem;
`;
